import React from 'react';
import { makeAutoObservable } from 'mobx';

class GlobalStore1 {
  count = 3;

  // headerVisible = true;
  footerButtonVisible = false;
  footerMobileVisible = false;
  footerDesktopVisible = false;

  constructor() {
    makeAutoObservable(this);
    // this.setFooterButtonVisible = this.setFooterButtonVisible.bind(this);
  }

  // setHeaderVisible(value) {
  //   this.headerVisible = value;
  // }

  setFooterButtonVisible(value) {
    this.footerButtonVisible = value;
  }

  setFooterMobileVisible(value) {
    this.footerMobileVisible = value;
  }

  setFooterDesktopVisible(value) {
    this.footerDesktopVisible = value;
  }
  
}

const globalStore1 = new GlobalStore1();
export default globalStore1;
